import React, { Suspense } from "react";

import { Routes, Route } from "react-router-dom";

// Import Routes all
import {
  userRoutes,
  authRoutes,
  serverErrorRoute,
  defaultRoutes,
} from "./app/router/routes";

// Import all middleware
import Authmiddleware from "./app/router/middleware/Authmiddleware";

// Import scss
import "./assets/scss/theme.scss";
import "./assets/scss/preloader.scss";

import Loader from "./components/Common/Loader";
import DialogHost from "./components/Common/DialogHost";

const VerticalLayout = React.lazy(() => import("./app/layouts/VerticalLayout"));
const HorizontalLayout = React.lazy(
  () => import("./app/layouts/HorizontalLayout")
);
const NonAuthLayout = React.lazy(() => import("./app/layouts/NonAuthLayout"));

const App = () => {
  let layoutType = "vertical";
  function getLayout() {
    let layoutCls: Object = VerticalLayout;
    switch (layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout: any = getLayout();
  return (
    <React.Fragment>
      <DialogHost />
      <Suspense fallback={<Loader />}>
        <Routes>
          {authRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
            />
          ))}

          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
              key={idx}
            />
          ))}

          {/* Ruta para errores del servidor (500) */}
          <Route
            path={serverErrorRoute.path}
            element={serverErrorRoute.element}
          />
          {/* Rutas por defecto y 404 */}
          {defaultRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Suspense>
    </React.Fragment>
  );
};

export default App;
